var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.svgIcon)?_c('div',{staticClass:"icon-outer-wrap",style:({ width: _vm.width + 'px', height: _vm.width + 'px' })},[_c('div',{staticClass:"icon-wrap"},[_c('img',{attrs:{"src":_vm.svgIcon,"alt":"icono"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }